import {ClientUserState} from '../ClientUserState'
import {TranslationObject} from '@colonist/i18n'
import {ColonistMembershipType} from '@colonist/types'

export class UIUtilsNotifications {
    private static readonly REQUEST_DATA_DELAY_MS: number = 500

    static canUseLiveNotificationService(): boolean {
        if(!ClientUserState.userState?.isLoggedIn) return false
        return true
    }

    static delayNotificationDataRequest(callback: () => void) {
        setTimeout(callback, this.REQUEST_DATA_DELAY_MS)
    }

    static getMembershipTitleFromType(membershipType: ColonistMembershipType): TranslationObject {
        switch(membershipType) {
            case ColonistMembershipType.EliteMonthly:
            case ColonistMembershipType.EliteYearly:
                return {key: 'strings:storePage.membership.title.elite'}
            case ColonistMembershipType.PlusMonthly:
            case ColonistMembershipType.PlusYearly:
                return {key: 'strings:storePage.membership.title.plus'}
            case ColonistMembershipType.PremiumMonthly:
            case ColonistMembershipType.PremiumYearly:
                return {key: 'strings:storePage.membership.title.premium'}
            case ColonistMembershipType.Holiday2023AllAccessPass:
                return {key: 'strings:colonistCommon.utils.bug'}
        }
    }
}
